import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Login/INIT_ERROR',
    PENDING: 'Login/INIT_PENDING',
    SUCCESS: 'Login/INIT_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
